import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../../assest/css/Services.css";
import { FaStar } from "react-icons/fa";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../Footer/Footer";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import { FaLaptopCode, FaPaintBrush, FaServer, FaCloud } from "react-icons/fa";
import Clients1 from "../../assest/image/Home/Clients/Clients (1).jpg";
import Clients2 from "../../assest/image/Home/Clients/Clients (2).jpg";
import Clients3 from "../../assest/image/Home/Clients/Clients (3).jpg";
import Clients4 from "../../assest/image/Home/Clients/Clients (4).png";
import Clients5 from "../../assest/image/Home/Clients/Clients (5).png";
import Clients6 from "../../assest/image/Home/Clients/Clients (6).png";
import Clients7 from "../../assest/image/Home/Clients/Clients (7).png";
import Clients8 from "../../assest/image/Home/Clients/Clients (8).png";
import Clients9 from "../../assest/image/Home/Clients/Clients (9).png";
import Clients10 from "../../assest/image/Home/Clients/Clients (10).png";
import Clients11 from "../../assest/image/Home/Clients/Clients (11).png";
import Clients12 from "../../assest/image/Home/Clients/Clients (12).png";
import Servicepatner from "../../assest/image/Services/Service - Who We Are.jpg";
import Slider from "react-slick";
import {
    FaCode,
    FaMobileAlt,
    FaShoppingCart,
    FaCogs,
    FaUsers,
} from "react-icons/fa";
import axios from "axios";
import Apiurl from "../environments/Apiurl";
import ImageApi from "../environments/ImageApi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FiArrowUpRight } from "react-icons/fi";

const servicesData = [
    {
        icon: <FaCode />,
        title: "Web Development",
        description:
            "Unlock the Full Potential of Your Online Presence with Our Comprehensive Web Development Services. From Static Websites to Responsive Dynamic Website Solutions, we craft innovative solutions for your digital success.",
        features: [
            "Responsive Design",
            "Content Management System",
            "Payment Gateway Integration",
            "User Authentication",
        ],
    },
    {
        icon: <FaMobileAlt />,
        title: "Mobile Apps Development",
        description:
            "Diversify your digital presence with our cross-platform expertise in mobile app development. From iOS to Android and beyond, we specialize in creating versatile applications that cater to all major mobile platforms.",
        features: [
            "User Authentication",
            "Payment Gateways",
            "Location-Based Services",
            "Multi-Platform Compatibility",
        ],
    },
    {
        icon: <FaShoppingCart />,
        title: "E-Commerce",
        description:
            "Transform your online business with our specialized E-commerce Development Services. From intuitive user interfaces to secure payment gateways, our expertise extends across the entire spectrum. Elevate your online store with comprehensive solutions.",
        features: [
            "Secure Payment Gateway",
            "Product Catalog Management",
            "Shopping Cart and Checkout",
            "Responsive for Mobile and Tablets",
        ],
    },
    {
        icon: <FaCogs />,
        title: "ERP Software Development",
        description:
            "At ATS, we excel in crafting advanced ERP solutions designed to enhance your business processes. From strategic planning to seamless implementation, our team ensures a tailored, scalable, and efficient ERP software.",
        features: [
            "Inventory Management",
            "Financial Management",
            "Human Resource Management",
            "Business Intelligence and Analytics",
        ],
    },
    {
        icon: <FaUsers />,
        title: "CRM Services",
        description:
            "Our CRM services are designed to elevate customer relationships and enhance business efficiency. We offer a comprehensive suite of CRM solutions tailored to meet your needs, including planning, implementation, customization, and ongoing support.",
        features: [
            "Lead Management",
            "Sales Pipeline Management",
            "Customer Interaction Tracking",
            "Workflow Automation",
        ],
    },
    {
        icon: <FaLaptopCode />,
        title: "Custom Software Development",
        description:
            "Our Custom Software Development services are designed to deliver solutions that perfectly align with your business goals. From concept to deployment, we create scalable, secure, and high-performance software tailored to your unique requirements.",
        features: [
            "Requirement Analysis & Planning",
            "Scalable & Secure Architecture",
            "Seamless Integration with Existing Systems",
            "Ongoing Maintenance & Support",
        ],
    },
];

const fallbackClients = [
    { src: Clients1, alt: "Client 1" },
    { src: Clients2, alt: "Client 2" },
    { src: Clients3, alt: "Client 3" },
    { src: Clients4, alt: "Client 4" },
    { src: Clients5, alt: "Client 5" },
    { src: Clients6, alt: "Client 6" },
    { src: Clients7, alt: "Client 7" },
    { src: Clients8, alt: "Client 8" },
    { src: Clients9, alt: "Client 9" },
    { src: Clients10, alt: "Client 10" },
    { src: Clients11, alt: "Client 11" },
    { src: Clients12, alt: "Client 12" },
];

const courses1 = [
    { id: 1, title: "Web Development" },
    { id: 2, title: "Mobile app Development" },
    { id: 3, title: "E- Commerce" },
    { id: 4, title: "ERP Software Development" },
    { id: 5, title: "CRM Service" },
    { id: 6, title: "Custom Software Development" },
];

const clientSliderSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 4 } },
        { breakpoint: 768, settings: { slidesToShow: 3 } },
        { breakpoint: 480, settings: { slidesToShow: 2 } }
    ]
};

const testimonialSliderSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

const Services = () => {
    const [submitMessage, setSubmitMessage] = useState('');
    const [testimonials, setTestimonials] = useState([]);
    const [clients, setClients] = useState(fallbackClients);
    const [formData, setFormData] = useState({
        firstName: "",
        email: "",
        phone: "",
        course: "",
        message: "",
    });
    const navigate = useNavigate();

    // Memoize cleanImageUrl to avoid recreating on every render
    const cleanImageUrl = useMemo(() => (url) => {
        if (!url) return "https://via.placeholder.com/300x200?text=No+Image";
        const baseUrl = ImageApi.replace(/\/$/, '');
        const cleanPath = url
            .replace(/^\/+/, '')
            .replace(/uploads/i, 'uploads')
            .replace(/\/uploads\/+uploads\//i, '/uploads/')
            .replace(/^(.*\/)uploads\//i, '$1uploads/');
        return `${baseUrl}/${cleanPath}`;
    }, []);

    // Memoize processed testimonials
    const processedTestimonials = useMemo(() =>
        testimonials.map(testimonial => ({
            review: testimonial.review || testimonial.text || testimonial.message || testimonial.comment || testimonial.description || testimonial.feedback || 'No review available yet. Contact us for testimonials!',
            name: testimonial.name || testimonial.client_name || 'Anonymous Client',
            company: testimonial.company || testimonial.client_company || 'Our Valued Partner',
            image: cleanImageUrl(testimonial.image),
        })), [testimonials, cleanImageUrl]
    );

    // Single useEffect for all fetches and init
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: "ease-out-cubic",
            once: true,
            offset: 100,
            delay: 100,
        });

        const fetchData = async () => {
            try {
                const [testimonialRes, clientRes] = await Promise.all([
                    axios.get(`${Apiurl}/review/client-review`),
                    axios.get(`${Apiurl}/portfolio/clients`)
                ]);

                // Process testimonials
                setTestimonials(testimonialRes.data);

                // Process clients
                const dynamicClients = clientRes.data.map((client, index) => ({
                    src: cleanImageUrl(client.client_logo),
                    alt: `Client ${index + 1}`,
                    id: client._id,
                }));
                setClients(dynamicClients);
            } catch (error) {
                console.error('Error fetching data:', error);
                // Fallback already set for clients
            }
        };

        fetchData();

        return () => {
            AOS.refresh();
        };
    }, [cleanImageUrl]);

    // Auto-hide message effect
    useEffect(() => {
        if (submitMessage) {
            const timer = setTimeout(() => setSubmitMessage(''), 5000);
            return () => clearTimeout(timer);
        }
    }, [submitMessage]);

    const handleInputChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        
        // Validate phone number (must be exactly 10 digits)
        if (formData.phone && formData.phone.length !== 10) {
            setSubmitMessage('Phone number must be exactly 10 digits.');
            return;
        }
        
        // Validate all required fields
        if (!formData.firstName.trim()) {
            setSubmitMessage('Name is required.');
            return;
        }
        
        if (!formData.email.trim()) {
            setSubmitMessage('Email is required.');
            return;
        }
        
        if (!formData.phone.trim()) {
            setSubmitMessage('Phone number is required.');
            return;
        }
        
        if (!formData.course) {
            setSubmitMessage('Please select a service type.');
            return;
        }
        
        if (!formData.message.trim()) {
            setSubmitMessage('Message is required.');
            return;
        }
        
        try {
            const submissionData = {
                name: formData.firstName,              // ✅ Changed from first_name to name
                email: formData.email,
                phone_number: formData.phone,
                type_of_services: formData.course,
                message: formData.message,
            };
            
            console.log("📤 Submitting data:", submissionData); // Debug log
            
            const response = await axios.post(`${Apiurl}/project-enquiries`, submissionData);
            
            console.log("✅ Response:", response.data); // Debug log
            
            setSubmitMessage('Thank you for your enquiry! We will contact you soon.');
            setFormData({
                firstName: "",
                email: "",
                phone: "",
                course: "",
                message: "",
            });
        } catch (error) {
            console.error("❌ Submission error:", error.response?.data || error);
            setSubmitMessage(
                error.response?.data?.message || 
                'Failed to submit enquiry. Please try again.'
            );
        }
    };

    return (
        <HelmetProvider>
            <div className="header" style={{ overflowX: "hidden" }}>
                <Helmet>
                    <title>Services - Aalan TechSoft | Software Development & Software Training in Salem</title>
                    <meta
                        name="description"
                        content="Discover our end-to-end services including software development, website design, app creation, digital marketing, and enterprise IT solutions."
                    />
                </Helmet>

                {/* Hero Section */}
                <div className="Service-hero">
                    <div className="about-content text-center">
                        <div className="hero-title-container">
                            <span className="badge-title">Services</span>
                            <br />
                            <h1 className="text-white fw-bold">Transform Your Business <br /> Expert Software Solutions</h1>
                        </div>
                    </div>
                </div>

                {/* About Section */}
                <section className="business-section py-5 bg-light">
                    <Container>
                        <Row className="align-items-center gy-5 gx-5">
                            <Col lg={6} className="mb-4 mb-lg-0 d-none d-lg-block" data-aos="fade-up">
                                <div className="image-wrapper">
                                    <img
                                        src={Servicepatner}
                                        alt="Business Meeting"
                                        className="img-fluid rounded shadow"
                                        loading="lazy"
                                    />
                                </div>
                            </Col>
                            <Col lg={6} data-aos="fade-up" className="text-start">
                                <h2 className="section-subtitle fw-bold mb-3">
                                    <span className="badge-title">Who We Are</span>
                                </h2>
                                <h2 className="section-title">
                                    ATS – Your Trusted
                                    <span className="highlight"> Software Development Partner</span> in
                                    Salem
                                </h2>
                                <p className="section-text">
                                    Aalan Tech Soft, a leading software development company in Salem,
                                    offers a wide array of software services tailored to meet diverse
                                    business needs. Specializing in custom software development, web
                                    and mobile app development, UI/UX design, e-commerce solutions,
                                    and enterprise software, we prioritize customer satisfaction and
                                    quality assurance.
                                </p>
                                <ul className="custom-list">
                                    <li>Trusted for expertise and excellence.</li>
                                    <li>Specialized in software, web, mobile, and UI/UX.</li>
                                    <li>Committed to on-time project delivery.</li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Services Section */}
                <section className="services-section py-5 text-center">
                    <Container>
                        <Row className="mb-5 justify-content-center">
                            <Col xs={12} md={10} lg={8} className="text-center">
                                <h2 className="fw-bold mb-3">
                                    <span className="badge-title">Our Services</span>
                                </h2>
                                <h2 className="section-title mt-3">
                                    Elevate Your Vision with Our Premier Software Development Services
                                </h2>
                            </Col>
                        </Row>
                        <Row className="g-4">
                            {servicesData.map((service, index) => (
                                <Col md={6} lg={4} key={index} data-aos="fade-up" data-aos-delay={(index + 1) * 150}>
                                    <div className="service-card g-2">
                                        <div className="icon-box mb-4" data-aos="zoom-in" data-aos-delay={(index + 1) * 150 + 100}>
                                            {service.icon}
                                        </div>
                                        <h5 className="service-title" data-aos="fade-up" data-aos-delay={(index + 1) * 150 + 200}>
                                            {service.title}
                                        </h5>
                                        <p className="card-text" data-aos="fade-up" data-aos-delay={(index + 1) * 150 + 300}>
                                            {service.description}
                                        </p>
                                        <ul className="custom-list" data-aos="fade-up" data-aos-delay={(index + 1) * 150 + 400}>
                                            {service.features.map((feature, i) => (
                                                <li key={i}>{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>

                {/* Clients Section */}
                <section className="clients-section py-5 bg-light">
                    <Container>
                        <Row className="mb-5 justify-content-center">
                            <Col xs={12} md={10} lg={8} className="text-center">
                                <h2 className="section-title mb-4">
                                    Our <span className="highlight">Trusted Clients</span>
                                </h2>
                                <p className="section-text text-center">
                                    We've partnered with companies for over 7 years to reimagine,
                                    reshape, and redefine the way people experience your business.
                                </p>
                            </Col>
                        </Row>
                        <Slider {...clientSliderSettings}>
                            {clients.map((client, index) => (
                                <div key={client.id || index} className="p-3">
                                    <div className="client-card">
                                        <img
                                            src={client.src}
                                            alt={client.alt}
                                            className="client-logo img-fluid"
                                            loading="lazy"
                                            onError={(e) => { e.target.src = Clients1; }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </Container>
                </section>

                {/* Contact Form Section */}
                <Container className="py-5">
                    <Row className="mb-5">
                        <Col xs={12} lg={6} className="text-start d-flex flex-column">
                            <h2 className="section-title">
                                Let's Build an awesome{" "}
                                <span style={{ color: '#85bf39' }}>project together</span>
                            </h2>
                            <p className="section-text" style={{ textAlign: "justify" }}>
                                Our IT company is dedicated to providing reliable support and solutions. Whether you need help with software, hardware, or network issues, we're here to keep your business running smoothly.
                            </p>
                            <ul className="icon-list mt-3 d-none d-lg-block">
                                <li className="d-flex align-items-center mb-3">
                                    <div className="icon-box"><FaLaptopCode /></div>
                                    <span className="section-text fw-semibold">Custom Web & App Development</span>
                                </li>
                                <li className="d-flex align-items-center mb-3">
                                    <div className="icon-box"><FaPaintBrush /></div>
                                    <span className="section-text fw-semibold">Creative UI/UX Design Solutions</span>
                                </li>
                                <li className="d-flex align-items-center mb-3">
                                    <div className="icon-box"><FaServer /></div>
                                    <span className="section-text fw-semibold">Robust ERP & Software Solutions</span>
                                </li>
                                <li className="d-flex align-items-center mb-3">
                                    <div className="icon-box"><FaCloud /></div>
                                    <span className="section-text fw-semibold">Cloud Integration & IT Support</span>
                                </li>
                            </ul>
                        </Col>
                        <Col xs={12} lg={6} className="mx-auto">
                            <Card className="contact-form-card custom-card-width shadow-lg rounded-4 p-3">
                                <Card.Body>
                                    <h3 className="contact-title mb-4" style={{ color: '#85bf39' }}>
                                        Service Enquiry Form
                                    </h3>
                                    <Form onSubmit={handleFormSubmit}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="form-label">Name *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                className="bg-white"
                                                value={formData.firstName}
                                                onChange={(e) => handleInputChange("firstName", e.target.value)}
                                                placeholder="Enter your full name"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="form-label">Email *</Form.Label>
                                            <Form.Control
                                                type="email"
                                                className="bg-white"
                                                value={formData.email}
                                                onChange={(e) => handleInputChange("email", e.target.value)}
                                                placeholder="Enter your email address"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="form-label">Phone Number *</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                className="bg-white"
                                                value={formData.phone}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, ''); // Only numbers
                                                    if (value.length <= 10) {
                                                        handleInputChange("phone", value);
                                                    }
                                                }}
                                                maxLength="10"
                                                placeholder="Enter 10-digit phone number"
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="form-label">Type of Services *</Form.Label>
                                            <Form.Select
                                                value={formData.course}
                                                onChange={(e) => handleInputChange("course", e.target.value)}
                                                required
                                            >
                                                <option value="">Select a service</option>
                                                {courses1.map((course) => (
                                                    <option key={course.id} value={course.title}>
                                                        {course.title}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="form-label">Message *</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                className="bg-white"
                                                value={formData.message}
                                                onChange={(e) => handleInputChange("message", e.target.value)}
                                                placeholder="Tell us about your project requirements"
                                                required
                                            />
                                        </Form.Group>
                                        <div className="text-start">
                                            <Button type="submit" className="btn btn-md sendmessage">
                                                Submit Enquiry
                                            </Button>
                                        </div>
                                    </Form>
                                    {submitMessage && (
                                        <div
                                            className={`mt-3 p-2 rounded ${submitMessage.includes('Thank you') ? 'bg-success text-white' : 'bg-danger text-white'}`}
                                            style={{ fontSize: '14px' }}
                                        >
                                            {submitMessage}
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Testimonials Section */}
                <section className="connect-section py-5 bg-light">
                    <Container>
                        <Row>
                            <Col md={4} className="left-col pe-4">
                                <h3 className="title">
                                    What Our <br /> Clients Say
                                </h3>
                                <p className="section-text justify-text" style={{ textAlign: "justify" }}>
                                    Hear from our satisfied clients who have experienced exceptional results
                                    through our software development and IT solutions.
                                </p>
                                <div className="d-flex justify-content-start mt-4">
                                    <Button
                                        className="custom-btn shadow-sm"
                                        onClick={() => {
                                            navigate("/contactus");
                                            window.scrollTo({ top: 0, behavior: "smooth" });
                                        }}
                                    >
                                        <span className="btn-text fw-semibold">Get a Quote</span>
                                        <span className="btn-icon ms-2">
                                            <FiArrowUpRight />
                                        </span>
                                    </Button>
                                </div>
                            </Col>
                            <Col md={8}>
                                <Slider {...testimonialSliderSettings}>
                                    {processedTestimonials.length > 0 ? (
                                        processedTestimonials.map((testimonial, index) => (
                                            <div key={index} className="px-3">
                                                <Card className="member-card">
                                                    <Card.Img
                                                        variant="top"
                                                        src={testimonial.image}
                                                        alt={testimonial.name}
                                                        className="member-img"
                                                        loading="lazy"
                                                    />
                                                    <Card.Body>
                                                        <Card.Text className="member-text">{testimonial.review}</Card.Text>
                                                        <p className="member-name">{testimonial.company}</p>
                                                        <h6 className="member-company">{testimonial.name}</h6>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ textAlign: 'center', padding: '20px' }}>
                                            <p>No testimonials available yet. We're building our client stories!</p>
                                        </div>
                                    )}
                                </Slider>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* FAQ Section */}
                <section className="faq-section py-5 px-md-4">
                    <div className="faq-container mx-auto px-3 px-sm-4">
                        <h2 className="text-center fw-bold mb-4 section-title">
                            Got Questions? <span style={{ color: "#85bf39" }}>We've Got Answers!</span>
                        </h2>
                        <p className="text-center mb-5 section-text">
                            Uncover everything you need to know about our Software Development Service with our FAQ section.
                        </p>
                        <Accordion defaultActiveKey="0" className="faq-accordion">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What types of software solutions do you offer?
                                </Accordion.Header>
                                <Accordion.Body className="fs-6 accordion-para" >
                                    We specialize in a wide range of software development services, including
                                    <b> web applications, mobile apps, custom software solutions, and more</b>.
                                    Whether you need a simple website or a complex enterprise system, we have you covered.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    Can you accommodate changes or updates to the project requirements during development?
                                </Accordion.Header>
                                <Accordion.Body className="fs-6 accordion-para">
                                    Flexibility is key to our approach. We understand that requirements may evolve over time,
                                    and we're prepared to accommodate changes or updates to ensure the final product meets your needs.
                                    Our <b>agile development methodology</b> allows for iterative development, making it easier
                                    to incorporate changes as needed.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    How long does it typically take to complete a project?
                                </Accordion.Header>
                                <Accordion.Body className="fs-6 accordion-para">
                                    Project timelines can vary depending on <b>complexity and requirements</b>.
                                    We'll work with you to establish realistic timelines and milestones to
                                    ensure smooth project delivery.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    How do we get started with a project?
                                </Accordion.Header>
                                <Accordion.Body className="fs-6 accordion-para">
                                    Simply reach out to us! We'll schedule an <b>initial consultation</b>
                                    to discuss your project requirements, goals, and next steps.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </section>

                <Footer />
            </div>
        </HelmetProvider>
    );
};

export default Services;